<template>
  <v-container class="documentation-page">
    <aside class="sidebar">
      <div class="module">
        <div
          @click="isShowAiIndexing = !isShowAiIndexing"
          class="parent-module d-flex flex-row justify-space-between"
        >
          <div>AI Indexing</div>

          <v-icon v-if="isShowAiIndexing">{{ mdiChevronDown }}</v-icon>
          <v-icon v-else>{{ mdiChevronRight }}</v-icon>
        </div>
        <transition name="drop-down">
          <div v-if="isShowAiIndexing" class="child-link ml-4 mt-2">
            <router-link to="/document">
              <div class="sub-title">Introduce</div></router-link
            >
          </div>
        </transition>
      </div>
      <div class="module">
        <div
          @click="isShowVisuallize = !isShowVisuallize"
          class="parent-module d-flex flex-row justify-space-between"
        >
          <div>AI Visuallize</div>

          <v-icon v-if="isShowVisuallize">{{ mdiChevronDown }}</v-icon>
          <v-icon v-else>{{ mdiChevronRight }}</v-icon>
        </div>
        <transition name="drop-down">
          <div
            v-if="isShowVisuallize"
            class="child-link d-flex flex-column ml-4 mt-2"
          >
            <router-link to="/document/dashboard">
              <div class="sub-title">Dashboard</div></router-link
            >
            <router-link to="/document/addtask">
              <div class="sub-title">Add Task</div></router-link
            >
            <router-link to="/document/listcontent">
              <div class="sub-title">List Content</div></router-link
            >
            <router-link to="/document/detailscontent">
              <div class="sub-title">Details Content</div></router-link
            >
          </div>
        </transition>
      </div>

      <div class="module">
        <div
          @click="isShowClipMaker = !isShowClipMaker"
          class="parent-module d-flex flex-row justify-space-between"
        >
          <div>AI Editor</div>

          <v-icon v-if="isShowClipMaker">{{ mdiChevronDown }}</v-icon>
          <v-icon v-else>{{ mdiChevronRight }}</v-icon>
        </div>
        <transition name="drop-down">
          <div v-if="isShowClipMaker" class="d-flex flex-column ml-4 mt-2">
            <router-link to="/document/aieditorapp">
              <div class="sub-title">Introduce</div></router-link
            >
            <router-link to="/document/timelinechart">
              <div class="sub-title">Timeline Chart</div></router-link
            >
            <router-link to="/document/indexingecommerce">
              <div class="sub-title">Interactive Ecommerce</div></router-link
            >
            <router-link to="/document/aiclipmaker">
              <div class="sub-title">AI Clip Maker</div></router-link
            >
            <router-link to="/document/adobe">
              <div class="sub-title">Adobe Premiere Pro</div></router-link
            >
          </div>
        </transition>
      </div>
      <div class="module">
        <div
          @click="isShowDeveloper = !isShowDeveloper"
          class="parent-module d-flex flex-row justify-space-between"
        >
          <div>Developer</div>

          <v-icon v-if="isShowDeveloper">{{ mdiChevronDown }}</v-icon>
          <v-icon v-else>{{ mdiChevronRight }}</v-icon>
        </div>
        <transition name="drop-down">
          <div v-if="isShowDeveloper" class="d-flex flex-column ml-4 mt-2">
            <router-link to="/document/descriptionjson">
              <div class="sub-title">Data JSON Format</div></router-link
            >
          </div>
        </transition>
      </div>
    </aside>

    <main class="screen-guideline">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>

    <transition name="fade" mode="out-in">
      <aside v-if="listTitle.length > 0" class="sidebar-follow">
        <div class="title-main">On This Page</div>

        <div class="d-flex flex-column" v-if="listTitle.length > 0">
          <a
            v-for="(name, index) in listTitle"
            :key="name + index"
            class="sub-title"
            :class="{ active: name === myAnchorTilte }"
            @click="addHash(name)"
          >
            {{ name.replace(/([A-Z])/g, " $1").trim() }}
          </a>
        </div>
      </aside>
    </transition>
  </v-container>
</template>

<script>
import { sync } from "vuex-pathify";
import { mdiChevronRight } from "@mdi/js";
import { mdiChevronDown } from "@mdi/js";
export default {
  data() {
    return {
      anChorTag: null,
      isShowAiIndexing: true,
      isShowVisuallize: true,
      isShowClipMaker: true,
      isShowDeveloper: true,
      mdiChevronRight: mdiChevronRight,
      mdiChevronDown: mdiChevronDown,
    };
  },
  computed: {
    listTitle: sync("showcase/myListTitle"),
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  watch: {},
  methods: {
    addHash(name) {
      let access = document.getElementById(`${name}`);
      window.scrollTo({
        top: access.offsetTop - 100,
        behavior: "smooth", // Optional, adds smooth scrolling animation
      });
      this.myAnchorTilte = name;
      localStorage.setItem("myAnchorTilte", name);
    },
  },
  mounted() {
    let nav = document.getElementById("nav");
    if (nav) {
      for (let el of nav.children) {
        if (el.id === "document") {
          el.classList.add("active");
        } else el.classList.remove("active");
      }
    }
    window.scrollTo(0, 2);
    document.getElementById("home").style.display = "none";
    let parent = document.querySelector(".sidebar").parentElement;
    while (parent) {
      const hasOverflow = getComputedStyle(parent).overflow;
      if (hasOverflow !== "visible") {
        parent.style.overflow = "visible";
      }
      parent = parent.parentElement;
    }
  },
};
</script>

<style lang="scss">
.documentation-page {
  display: flex;
  margin-bottom: 100px;
  overflow: visible !important;
  max-width: 1400px !important;

  @media only screen and (max-width: 1024px) {
    .sidebar {
      display: none;
    }
    .sidebar-follow {
      display: none !important;
    }
    .screen-guideline {
      width: 100% !important;
    }
  }

  .sidebar {
    width: 19%;
    height: 85vh;
    position: -webkit-sticky;
    position: sticky !important;
    top: 100px !important;
    padding: 10px;
    overflow: auto;
    .module {
      margin-bottom: 15px;
      display: flex;
      flex-direction: column;
      .parent-module {
        background-color: #fff;
        border-radius: 3px;
        padding: 8px;
        font-weight: bold;
        transition: 0.5s all;
        cursor: pointer;
        &:hover {
          color: #29b37f;
          opacity: 0.9;
        }
      }
      .child-link {
        transition: 0.2s all;
      }
      .drop-down-enter-active,
      .drop-down-leave-active {
        transition: all 0.2s ease-out;
      }

      .drop-down-enter,
      .drop-down-leave-to {
        transform: translateY(-20%);
        opacity: 0;
      }
      a {
        color: black;
        text-decoration: none;
        transition: 0.2s all;
        &:hover {
          color: #29b37f !important;
        }
      }
      .router-link-exact-active {
        color: #29b37f !important;
      }
      .title {
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
  .sidebar-follow {
    width: 15%;
    height: 35vh;
    position: -webkit-sticky;
    position: sticky !important;
    top: 100px !important;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    .title-main {
      font-weight: 700;
      font-size: 15px;
    }
    .sub-title {
      margin-left: 3px;
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 5px;
      padding: 0px 0px 0px 5px;
      cursor: pointer;
      &:hover {
        color: #29b37f;
      }
    }
    .active {
      color: #29b37f;
      border-left: 5px solid #29b37f;
      border-radius: 2px;
    }
  }
  .screen-guideline {
    width: 68%;
    padding: 10px 20px 20px 20px;
    border-radius: 5px;
    margin-top: 50px;
    .highlight-text {
      color: #29b37f;
      font-weight: 600;
    }
    p {
      margin-bottom: 5px !important;
    }
    .table-ultil-all-page {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
      td,
      th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
      }

      tr:nth-child(even) {
        background-color: #d5e3cf;
      }
      tr:nth-child(odd) {
        background-color: #ebf1e9;
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
